import React from 'react';
import { talleres } from '../DataFiles/talleres';

class Talleres extends React.Component {
    
    render(){
               
        return (
            <section className="speakers-area-two talleres ptb-120">
                <div className="container">
                    
                    
                    {talleres.map(taller=>(
                        <div className="row">
                            <div className="partner-title platinum-sponsor ">
                            <h3 className="lax" data-lax-preset="driftRight">{taller.name}</h3>
                            <h6>{taller.description}</h6>
                            </div>
                            
                            {taller.sub_talleres.map(st=>(
 
                            <>
 
                                <div className="col-lg-3 col-sm-6 partner-item">
                                    {st.logo!==""&&<img className='organizer' src={st.logo} alt={st.organizer} />}
                                </div>
                                <div  className="col-lg-8 col-sm-12">
                                    <h4>
                                        {st.name}
                                    </h4>
                                    <h4 className='organizador-taller'>
                                        {st.organizer}
                                    </h4>
                                    <p>
                                        {st.description}
                                    </p>
                                </div>
                            </>
                            ))}

                        </div>
                    ))}
                    
                </div>  
            </section>
        );
    }
}
 
export default Talleres;